import Logo from '../src/Logo/index.tsx';
export default Logo;
